<div class="login-dialog-welcome"></div>
<div>
  <h1>Welcome to LINQ ERP!</h1>
  @if (users?.length && !(framesUser$ | async) && (isReady$ | async)) {
    <div class="login-dialog-users">
      <label style="padding-right: 5px">Select a User:</label>
      <select (change)="userOnChange($event)">
        <option value=""></option>
        @for (user of users; track user) {
          <option [value]="user">{{ user }}</option>
        }
      </select>
    </div>
  }
  @if (visibility$()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (errorMessage) {
    <div class="login-dialog-error">{{ errorMessage }}</div>
  }
  @if (isAuthenticated$ | async) {
    <div class="center linq-pt-2">
      <button class="linq-button" mat-flat-button color="primary" (click)="onLogout()">Logout</button>
    </div>
  }
</div>
